import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { BaseDialogActionData, ButtonColor, CommonActionKey } from "common";

@Component({
  selector: "ifp-offer-accepted-dialog",
  templateUrl: "./offer-accepted-dialog.component.html",
  styleUrls: ["./offer-accepted-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OfferAcceptedDialogComponent {
  readonly actions: BaseDialogActionData[] = [
    { actionKey: CommonActionKey.GoToDashboard, label: "GO TO DASHBOARD", buttonColor: ButtonColor.Default },
  ];

  constructor(
    private readonly dialogRef: MatDialogRef<OfferAcceptedDialogComponent>,
  ) {}

  onActionClicked(): void {
    this.dialogRef.close();
  }
}
